import { VOUCHERS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import vouchersTypes from '../../constants/vouchersTypes'
import { axios } from '../../services'

//  PUBLISH AND UNPUBLISH AND REVOKE
const activate_voucher_request = () => {
  return {
    type: vouchersTypes.publish.request
  }
}

const activate_voucher_success = (response) => {
  return {
    type: vouchersTypes.publish.success,
    payload: response.data
  }
}

const activate_single_voucher_success = (response) => {
  return {
    type: vouchersTypes.publish.single,
    payload: response.data
  }
}

const activate_voucher_failure = (messages) => {
  if (messages.constructor === Array) {
    window.showSnackbar('error', messages.join("\n"))
  }
  return {
    type: vouchersTypes.publish.failure,
    payload: messages
  }
}

const activate_voucher = (voucher_id, index=false, page=1, per_page=10, filters={}, sort="", order="") => {
  return function(dispatch) {
    // Before Request
    dispatch( activate_voucher_request() )
    const reqParams = index ? {
      index: true,
      page: page,
      per_page: per_page,
      sort: sort,
      order: order,
      filters: filters
    } : {index: false}
    // Request
    axios.post(
      formatRoute(VOUCHERS_ROUTES.activate, {id: voucher_id}),
      reqParams
    ).then( response => {
      window.showSnackbar('success', 'The voucher status has changed to: Active.')
      if ( index ) {
        dispatch( activate_voucher_success(response) )

      } else {
        dispatch( activate_single_voucher_success(response) )

      }
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error activating voucher"]
      }
      dispatch( activate_voucher_failure( errors ) )
    })
  }
}

const revoke_voucher = (voucher_id, index=false, page=1, per_page=10, filters={}, sort="", order="") => {
  return function(dispatch) {
    // Before Request
    dispatch( activate_voucher_request() )
    const reqParams = index ? {
      index: true,
      page: page,
      per_page: per_page,
      sort: sort,
      order: order,
      filters: filters
    } : {index: false}
    // Request
    axios.post(
      formatRoute(VOUCHERS_ROUTES.revoke, {id: voucher_id}),
      reqParams
    ).then( response => {
      window.showSnackbar('success', 'The voucher status has changed to: Revoked.')
      if ( index ) {
        dispatch( activate_voucher_success(response) )

      } else {
        dispatch( activate_single_voucher_success(response) )

      }
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error revoking voucher."]
      }
      dispatch( activate_voucher_failure( errors ) )
    })
  }
}

const resend_voucher = (voucher_id, index=false, page=1, per_page=10, filters={}, sort="", order="") => {
  return function(dispatch) {
    // Before Request
    dispatch( activate_voucher_request() )
    const reqParams = index ? {
      index: true,
      page: page,
      per_page: per_page,
      sort: sort,
      order: order,
      filters: filters
    } : {index: false}
    // Request
    axios.post(
      formatRoute(VOUCHERS_ROUTES.resend, {id: voucher_id}),
      reqParams
    ).then( response => {
      window.showSnackbar('success', 'A new notification has been sent to user.')
      if ( index ) {
        dispatch( activate_voucher_success(response) )

      } else {
        dispatch( activate_single_voucher_success(response) )

      }
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error sending notification."]
      }
      dispatch( activate_voucher_failure( errors ) )
    })
  }
}


export {
  activate_voucher,
  revoke_voucher,
  resend_voucher
}



// WEBPACK FOOTER //
// ./src/js/actions/vouchers/publish.js